import Vue from 'vue/dist/vue.esm'
import WickGuidePage from 'components/storefront/wick-guide.vue'

export default function buildWickGuideApp(element) {
  new Vue({
    el: element,
    components: {
      WickGuidePage
    }
  })
}
